<template>
  <div class="row q-gutter-y-sm">
    <div class="col-xs-6 text-white q-pr-xs">
      <q-card flat class="bg-pragma">
        <q-card-section class="text-caption q-pa-xs text-bold">
          Nro de solicitud
        </q-card-section>
        <q-card-section class="q-pa-xs">
          {{solicitud.numero}}
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-6 text-white q-pl-xs">
      <q-card flat class="bg-grey-9">
        <q-card-section class="text-caption q-pa-xs text-bold">
          Fecha limite
        </q-card-section>
        <q-card-section class="q-pa-xs">
          {{vmoment(solicitud.fecha_limite).format('DD/MM/YYYY')}}
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 text-white" v-if="!solicitud.proyecto.nombre">
      <q-card flat class="bg-grey-9">
        <q-card-section class="text-caption q-pa-xs text-bold">
          Proyecto
        </q-card-section>
        <q-card-section class="q-pa-xs">
          {{solicitud.proyecto}}
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 text-white" v-if="!solicitud.proyecto.nombre">
      <q-card flat class="bg-grey-9">
        <q-card-section class="text-caption q-pa-xs text-bold">
          Solicitante
        </q-card-section>
        <q-card-section class="q-pa-xs">
          {{solicitud.usuario}}
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 text-white" v-if="!solicitud.proyecto.nombre">
      <q-card flat class="bg-pragma">
        <q-card-section class="text-caption q-pa-xs text-bold">
          Modalidad
        </q-card-section>
        <q-card-section class="q-pa-xs">
          {{solicitud.modalidad}}
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12" v-if="!solicitud.proyecto.nombre">
      <div class="row">
        <div :class="solicitud.tipo_cambio !== 1 ? 'col-xs-6 q-pr-xs' : 'col-xs-12'">
          <q-card flat class="bg-grey-9 text-white">
            <q-card-section class="text-caption q-pa-xs text-bold">
              Moneda
            </q-card-section>
            <q-card-section class="q-pa-xs">
              {{solicitud.moneda}}
            </q-card-section>
          </q-card>
        </div>
        <div class="col-xs-6 q-pl-xs" v-if="solicitud.tipo_cambio !== 1">
          <q-card flat class="bg-grey-9 text-white">
            <q-card-section class="text-caption q-pa-xs text-bold">
              Tipo de cambio
            </q-card-section>
            <q-card-section class="q-pa-xs text-right">
              {{solicitud.tipo_cambio}}
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
    <div class="col-xs-12 text-white">
      <q-card flat class="bg-grey-9">
        <q-card-section class="text-caption q-pa-xs text-bold">
          Referencia
        </q-card-section>
        <q-card-section class="q-pa-xs">
          {{solicitud.referencia}}
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 text-white">
      <q-card flat class="bg-grey-9">
        <q-card-section class="text-caption q-pa-xs text-bold">
          Justificación
        </q-card-section>
        <q-card-section class="q-pa-xs">
          {{solicitud.observacion}}
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['solicitud'],
  setup () {
    // Variables del componente
    const vmoment = moment
    return {
      vmoment
    }
  }
}
</script>

<style>

</style>